import {createContext } from "react";


const ReposContext = createContext({
    InputRepo: null,
    OutputRepo: null,
    InputRepoCreds:null,
    OutputRepoCreds:null,
    srcFileTree:null,
    destFileTree:null,
    setSrcFileTree:null,
    setDestFileTree:null,
    currInputContent:null,
    currOutputContent:null,
    setCurrInputContent:null,
    setCurrOutputContent:null,
}
);

export default ReposContext;